import React from "react";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";
import {CommentFragment} from "../../public/journey1/fragments/CommentFragment";
import {saveComment} from "../../actions/createAppointmentActions";
import * as types from "../../constants/ActionTypes";
import {getComment, getVin} from "../../selectors/createAppointmentRequest";
import {getSelectedDealerId} from "../../selectors/customerDealer";
import FieldError from "../common/input/FieldError";

class MessageInformation extends React.Component {

  componentDidMount = () => {
    const {dealerId, vin} = this.props;
    dealerId && this.props.dispatchFetchPreJourneyInfo({dealerId, untrustedVin: vin});
  }

  onCommentChange = (value) => {
    this.props.dispatchSaveComment(value);
  };

  render() {
    const {intl: {formatMessage}, comment} = this.props;

    return (
      <React.Fragment>
        <CommentFragment
          formatMessage={formatMessage}
          onChange={(e) => this.onCommentChange(e.target.value)}
          comment={comment}
          title={'call.center.journey.message.title'}
          minRows={5}
          maxRows={5}
        />
        {!comment &&
          <FieldError error={{message: 'customer.journey.pleaseChoose'}}/>
        }
      </React.Fragment>
    );
  }

}

const mapDispatchToProps = dispatch => ({
  dispatchSaveComment: payload => dispatch(saveComment(payload)),
  dispatchFetchPreJourneyInfo: params => dispatch({type: types.FETCH_PRE_JOURNEY_INFORMATION, params})
});

const mapStateToProps = state => ({
  comment: getComment(state),
  dealerId: getSelectedDealerId(state),
  vin: getVin(state)
});

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(MessageInformation));
